module.exports = __webpack_public_path__ + "static/media/Results_Glyph_Standby.3d23e980.png";